import { createFileRoute } from '@tanstack/react-router'
import { PurchaseOrdersList } from '@/features/parts/purchase-orders'
import { requireFlow } from '@/features/auth/guards'

export const Route = createFileRoute('/_authenticated/service/purchase-orders/')({
  beforeLoad: requireFlow('service'),
  component: PurchaseOrdersPage,
})

function PurchaseOrdersPage() {
  return <PurchaseOrdersList />
}
